<template>
    <div>
        <div class="form-grid">
            <div v-if="userRole !== 'pro' && userRole !== 'pro+'">
                <span class="lbl">Recette publique</span>
                <div class="seg" role="group" aria-label="Recette publique">
                    <button type="button" class="seg-btn" :aria-pressed="recipe.scope_recipe === 'public' ? 'true' : 'false'" @click="recipe.scope_recipe = 'public'">Oui</button>
                    <button type="button" class="seg-btn" :aria-pressed="recipe.scope_recipe !== 'public' ? 'true' : 'false'" @click="recipe.scope_recipe = 'owner'">Non</button>
                </div>
            </div>
            <div>
                <label class="lbl">Type de plat</label>
                <el-select popper-class="calc-pop" clearable v-model="recipe.category_id" placeholder="Sélectionner">
                    <el-option v-for="category in options.categories" :label="category.name" :key="category.id" :value="category.id"></el-option>
                </el-select>
            </div>
            <div>
                <label class="lbl">Catégorie</label>
                <el-select popper-class="calc-pop" clearable multiple v-model="recipe.subcategories_ids" placeholder="Sélectionner">
                    <el-option v-for="subcategory in options.subcategories" :label="subcategory.name" :key="subcategory.id" :value="subcategory.id"></el-option>
                </el-select>
            </div>
            <div>
                <label class="lbl">Budget (€)</label>
                <el-select popper-class="calc-pop" clearable v-model="recipe.budget" placeholder="Sélectionner">
                    <el-option v-for="(budget, index) in options.budget" :label="budget.label" :key="index" :value="budget.value"></el-option>
                </el-select>
            </div>
            <div>
                <label class="lbl">Temps de préparation (min)</label>
                <el-select popper-class="calc-pop" clearable v-model="recipe.preparation_minutes" placeholder="Sélectionner">
                    <el-option v-for="(minutes, index) in options.minutes" :label="minutes + ' minutes'" :key="index" :value="minutes"></el-option>
                </el-select>
            </div>
            <div>
                <label class="lbl">Temps de cuisson (min)</label>
                <el-select popper-class="calc-pop" clearable v-model="recipe.cuisson_minutes" placeholder="Sélectionner">
                    <el-option v-for="(minutes, index) in options.minutes" :label="minutes + ' minutes'" :key="index" :value="minutes"></el-option>
                </el-select>
            </div>
            <div>
                <label class="lbl">Facilité de préparation</label>
                <el-select popper-class="calc-pop" clearable v-model="recipe.facilite" placeholder="Sélectionner">
                    <el-option v-for="(facilite, index) in options.facilite" :label="facilite.label" :key="index" :value="facilite.value"></el-option>
                </el-select>
            </div>
            <div v-if="userRole !== 'pro' && userRole !== 'pro+'">
                <label class="lbl" for="recipe-video">Vidéo</label>
                <input id="recipe-video" v-model="recipe.video" type="text" class="field w-100" placeholder="Saisir l'URL de la vidéo">
            </div>
            <div v-if="userRole !== 'user'">
                <span class="lbl">Photo</span>
                <button type="button" class="ghost-btn sm" @click="$emit('choose-picture')">Choisir un fichier</button>
                <div v-if="recipe.picture_url" class="mt-2"><img :src="recipe.picture_url" alt="Photo de la recette" style="max-height:120px;border-radius:8px"></div>
            </div>
            <div class="full">
                <label class="lbl" for="recipe-text">Étapes de la recette</label>
                <el-input id="recipe-text" type="textarea" :rows="4" v-model="recipe.text" placeholder="Ajouter les étapes de votre préparation en allant à la ligne pour chaque étape"></el-input>
            </div>
        </div>
        <div class="manual-actions mt-3" v-if="recipe.id">
            <button type="button" class="ghost-btn" @click="$emit('transform')">Transformer en ingrédient</button>
            <form v-if="userRole === 'admin' || userRole === 'pro+'" ref="dupForm" method="post" :action="'/pro/recipes/' + recipe.id + '/duplicate'" @submit.prevent="confirmDuplicate">
                <input type="hidden" name="_token" :value="csrf">
                <button type="submit" class="ghost-btn">Dupliquer la recette</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecipeDetailsCard',
    props: {
        recipe: {type: Object, required: true},
        userRole: {type: String, default: ''},
        options: {type: Object, required: true},
        csrf: {type: String, default: ''},
    },
    methods: {
        confirmDuplicate() {
            this.$confirm('Dupliquer cette recette ? Vous serez redirigé vers la liste des recettes.', 'Dupliquer', {
                confirmButtonText: 'Dupliquer', cancelButtonText: 'Annuler', type: 'warning', customClass: 'calc-confirm',
            }).then(() => { this.$refs.dupForm.submit(); }).catch(() => {});
        },
    },
};
</script>
